"use strict";

/* -------------------------------------------------------------------------

	PUNITED.business

	トップページのスクリプトを定義
	※jQuery必須
	Potential United inc.

------------------------------------------------------------------------- */
// グローバル名前空間定義
var PUNITED;
if (!PUNITED) PUNITED = {};
if (!PUNITED.business) PUNITED.business = {};

(function () {
  // グローバル名前空間オブジェクトをローカルオブジェクトに置き換え
  var ns = PUNITED.business;
  /* -----------------------------------------------------
  
  ----------------------------------------------------- */
})();

$(function () {
  PUNITED.utils.headLine({
    width: 1809.812,
    height: 150.21,
    d: [{
      command: 'M',
      points: [[-13660.516, -11704.543]]
    }, {
      command: 'c',
      points: [[-110.166, -65.755], [-225.97, 94.119], [-470.829, 87.443]]
    }, {
      command: 's',
      points: [[-316.566, -70.014], [-727.5, -30.844], [-610.785, 75.859], [-610.785, 75.859]]
    }],
    translate: [15469.814, 11721.311]
  }, {
    width: 462.504,
    height: 39.819,
    d: [{
      command: 'M',
      points: [[-15007.822, -11716.384]]
    }, {
      command: 'c',
      points: [[-28.122, -16.786], [-57.684, 24.024], [-120.187, 22.321]]
    }, {
      command: 's',
      points: [[-80.811, -17.873], [-185.71, -7.874], [-155.913, 19.365], [-155.913, 19.365]]
    }],
    translate: [15469.813, 11721.407]
  });
});